/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthHistoryDto } from '../../models/growth-history-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface ProductControllerSearchGrowthHistory$Params {
  id: string;

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 돼지 개체 ID
 */
  pigId?: string;

/**
 * 상품 ID
 */
  productId?: string;

/**
 * 공개 여부 필터 (true: 공개만, false: 비공개만, 미입력: 전체)
 */
  isPublic?: string;
}

export function productControllerSearchGrowthHistory(http: HttpClient, rootUrl: string, params: ProductControllerSearchGrowthHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, productControllerSearchGrowthHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('pigId', params.pigId, {});
    rb.query('productId', params.productId, {});
    rb.query('isPublic', params.isPublic, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<GrowthHistoryDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

productControllerSearchGrowthHistory.PATH = '/api/product/{id}/growth-history';
